import "core-js/modules/es.array.push.js";
import { StyleTextarea } from "@/components/StyleTextarea.vue";
import { StyleSwitch } from "@/components/StyleSwitch.vue";
import { Dialog, DialogPanel, DialogTitle, TransitionChild, TransitionRoot } from "@headlessui/vue";
import { ChatBubbleLeftRightIcon } from "@heroicons/vue/24/outline";
import { mapGetters } from "vuex";
import * as Sentry from "@sentry/vue";
import service from "@/service";
import Message from "@/components/message.js";
import { isShowQuestionDialog } from "@/utils";
export default {
  name: "HeaderFeedback",
  components: {
    ChatBubbleLeftRightIcon,
    TransitionRoot,
    TransitionChild,
    Dialog,
    DialogPanel,
    DialogTitle,
    StyleTextarea,
    StyleSwitch
  },
  data() {
    return {
      isDialogOpen: false,
      form: {
        content: "",
        attachSettings: false,
        attachScreenshot: false
      },
      openBeforeQuestionnaire: false
    };
  },
  watch: {
    "$route.hash"(newHash) {
      if (newHash === "#questionnaire" && this.isDialogOpen === true) {
        this.isDialogOpen = false;
        this.openBeforeQuestionnaire = true;
      } else {
        if (this.openBeforeQuestionnaire === true) {
          this.openBeforeQuestionnaire = false;
          this.isDialogOpen = true;
        }
      }
    }
  },
  computed: {
    ...mapGetters("SettingModule", ["settings"]),
    ...mapGetters(["screenshot"])
  },
  methods: {
    feedbackForm() {
      this.$router.push({
        hash: "#questionnaire"
      });
      // Message.text(this.$i18n.locale === 'zh' ? "尚未开放，敬请期待！" : "Coming Soon")
    },
    openDialog() {
      this.isDialogOpen = true;
    },
    closeDialogFromMusk() {
      if (isShowQuestionDialog()) {
        return;
      }
      this.isDialogOpen = false;
    },
    closeDialog() {
      if (isShowQuestionDialog()) {
        return;
      }
      this.isDialogOpen = false;
      this.resetForm();
    },
    resetForm() {
      this.form = {
        content: ""
      };
    },
    async autoFeedback({
      name,
      email,
      message
    }) {
      try {
        const response = await service({
          url: "/api/create_feedback",
          method: "post",
          data: {
            name,
            email,
            message
          }
        });
        const feedback = response.data;
        Message.text(this.$t("HeaderView.HeaderFeedback.feedbackSuccess"));
      } catch (error) {
        Message.text(this.$t("HeaderView.HeaderFeedback.feedbackFailed"));
      }
    },
    async submitFeedback() {
      const userFeedback = {
        name: "",
        email: "",
        message: this.form.content
      };
      await this.autoFeedback(userFeedback);
      if (this.form.attachScreenshot) {
        userFeedback.message += `\n\n${JSON.stringify(this.screenshot)}`;
      } else if (this.form.attachSettings) {
        userFeedback.message += `\n\n${JSON.stringify(this.settings)}`;
      }
      Sentry.captureFeedback(userFeedback, {
        captureContext: {
          tags: {
            feedbackType: "user_initiated",
            subject: this.form.subject
          }
        }
      });
      this.closeDialog();
    }
  }
};